import { render, staticRenderFns } from "./inputMainImage.vue?vue&type=template&id=f79f2870&scoped=true&"
import script from "./inputMainImage.vue?vue&type=script&lang=js&"
export * from "./inputMainImage.vue?vue&type=script&lang=js&"
import style0 from "./inputMainImage.vue?vue&type=style&index=0&id=f79f2870&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79f2870",
  null
  
)

export default component.exports